var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaptureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1363_14024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9844 19C23.9844 19.5304 23.7737 20.0391 23.3986 20.4142C23.0235 20.7893 22.5148 21 21.9844 21H3.98438C3.45394 21 2.94523 20.7893 2.57016 20.4142C2.19509 20.0391 1.98438 19.5304 1.98438 19V8C1.98438 7.46957 2.19509 6.96086 2.57016 6.58579C2.94523 6.21071 3.45394 6 3.98438 6H7.98438L9.98438 3H15.9844L17.9844 6H21.9844C22.5148 6 23.0235 6.21071 23.3986 6.58579C23.7737 6.96086 23.9844 7.46957 23.9844 8V19Z",
    stroke: "#C09B73",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9844 17C15.1935 17 16.9844 15.2091 16.9844 13C16.9844 10.7909 15.1935 9 12.9844 9C10.7752 9 8.98438 10.7909 8.98438 13C8.98438 15.2091 10.7752 17 12.9844 17Z",
    stroke: "#C09B73",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1363_14024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.984375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureIcon);
export default __webpack_public_path__ + "static/media/capture_icon.e5d62b5bd6511babec492758fff5c081.svg";
export { ForwardRef as ReactComponent };